import { tv } from "tailwind-variants";

export const checkableStyles = tv({
  slots: {
    itemRoot:
      "relative flex cursor-pointer gap-2 transition-all duration-100 has-disabled:cursor-not-allowed has-disabled:[&_*]:cursor-not-allowed",
    input: [
      "shrink-0 overflow-hidden border border-neutral-400 bg-white ring-2 ring-transparent ring-offset-white outline-0 transition-all duration-100",

      "enabled:active:border-neutral-500 enabled:active:ring-secondary-200 enabled:active:ring-offset-1 enabled:active:ring-offset-secondary-700 disabled:cursor-not-allowed disabled:border-neutral-600",

      "focus:border-secondary-700 focus:ring-secondary-200 focus:ring-offset-1 disabled:bg-neutral-100 data-[state=checked]:enabled:border-secondary-600 data-[state=checked]:enabled:bg-secondary-100",

      "data-[state=unchecked]:enabled:hover:border-neutral-600 data-[state=unchecked]:enabled:focus:border-neutral-700 data-[state=unchecked]:enabled:active:bg-secondary-50",
    ],
    label: "block w-full text-neutral-950",
    description: "description text-sm text-neutral-800",
  },
  variants: {
    size: {
      base: {
        input: "size-4",
      },
      lg: {
        input: "size-5",
      },
    },
    isCard: {
      true: {
        itemRoot:
          "rounded-lg border border-neutral-200 bg-white p-3 has-focus:border-secondary-400 has-enabled:hover:border-neutral-400 has-enabled:active:border-secondary-400 has-enabled:active:bg-secondary-50 has-enabled:has-data-[state=checked]:border-secondary-200 has-enabled:has-data-[state=checked]:bg-secondary-100 has-disabled:has-data-[state=checked]:[&_span]:text-secondary-700 has-disabled:has-data-[state=unchecked]:[&_span]:text-neutral-800",
      },
    },
    isError: {
      true: {
        input:
          "border-red-700 hover:border-red-800! data-[state=unchecked]:focus:border-red-700!",
      },
    },
    hideIndicator: {
      true: {
        input: "sr-only",
      },
    },
  },

  defaultVariants: {
    size: "base",
    isCard: false,
    hideIndicator: false,
  },
});
